// import { Tabs } from "antd";
import { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import BasicCompInfo from "./BasicCompInfo";
import SettingsPageLayout from "../SettingsPageLayout";
// import SubscriptionInfo from "./SubscriptionInfo";

const CompanyInfo = ({ companyData, initialLoading, fetchCompanyData }) => {
    const { t } = useTranslation("settings");
    const [headerActions, setHeaderActions] = useState(null);

    return (
        <SettingsPageLayout
            title={t("companyInformation")}
            description={t("companyInformationDescription")}
            actions={headerActions}>
            <BasicCompInfo
                fetchCompanyData={fetchCompanyData}
                initialLoading={initialLoading}
                companyData={companyData}
                hideActionBar
                onRegisterHeaderActions={setHeaderActions}
            />
        </SettingsPageLayout>
    );
};
CompanyInfo.propTypes = {
    companyData: PropTypes.object,
    initialLoading: PropTypes.bool,
    fetchCompanyData: PropTypes.func,
};
export default CompanyInfo;
